interface MyAppGridProps {
  apps: any[];
  onOpen: (app: any) => void;
}

export function MyAppsGrid({
  apps,
  onOpen,
}: MyAppGridProps) {
  return (
    <div
      className="
        grid
        grid-cols-2
        sm:grid-cols-3
        lg:grid-cols-4
        gap-4
      "
    >
      {apps.map((app) => (
        <button
          key={app.key}
          onClick={() => onOpen(app)}
          className="
            bg-white
            rounded-2xl
            p-5
            border
            text-left
            hover:shadow-lg
            hover:-translate-y-1
            transition
          "
        >
          <div
            className="
              h-12
              w-12
              rounded-xl
              bg-slate-100
              flex
              items-center
              justify-center
              mb-4
            "
          >
            {app.icon}
          </div>

          <h3 className="font-semibold">
            {app.title}
          </h3>

          <p className="text-sm text-slate-500 mt-1">
            {app.description}
          </p>
        </button>
      ))}
    </div>
  );
}